<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <a mat-button routerLink="/employees/rrhh/skill-questions">
        <mat-icon>arrow_back</mat-icon>
        Banco de preguntas
      </a>
      <h1 class="mb-0">{{ page_title }}</h1>
    </div>
    <div class="page-actions d-flex gap-2">
      <button mat-button type="button" (click)="cancel()">Cancelar</button>
      <button mat-flat-button color="accent" type="button" [disabled]="loading() || loading_data() || form.invalid" (click)="save()">
        Guardar
      </button>
    </div>
  </div>

  @if (loading_data()) {
    <p>Cargando...</p>
  } @else {
    <form [formGroup]="form" class="question-form card p-3">
      <section class="form-section">
        <h2>Datos de la pregunta</h2>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="type" placeholder="Selecciona el tipo de pregunta">
            @for (type_option of skill_question_type_options; track type_option.value) {
              <mat-option [value]="type_option.value">{{ type_option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Enunciado</mat-label>
          <textarea matInput formControlName="body" rows="5" placeholder="Escribe el enunciado de la pregunta..."></textarea>
        </mat-form-field>

        <div class="metadata-row" [class.metadata-row-three-columns]="is_text_type()">
          <mat-form-field appearance="outline" class="metadata-field">
            <mat-label>Skills relacionadas</mat-label>
            <mat-select formControlName="skill_ids" multiple placeholder="Selecciona skills">
              @for (skill of skills(); track skill.id) {
                <mat-option [value]="skill.id">{{ skill.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="metadata-field">
            <mat-label>Minutos aproximados (opcional)</mat-label>
            <input matInput type="number" formControlName="approximate_minutes" min="1" placeholder="Ej. 15" />
          </mat-form-field>

          @if (is_text_type()) {
            <mat-form-field appearance="outline" class="metadata-field">
              <mat-label>Líneas de respuesta (opcional)</mat-label>
              <input matInput type="number" formControlName="answer_lines" min="1" max="50" placeholder="Ej. 5" />
            </mat-form-field>
          }
        </div>
      </section>

      @if (is_test_type()) {
        <section class="form-section">
          <div class="section-header">
            <h2>Opciones de respuesta</h2>
            <button mat-stroked-button type="button" (click)="addOption()">
              <mat-icon>add</mat-icon>
              Añadir opción
            </button>
          </div>

          @for (option_control of options_form_array.controls; track $index; let option_index = $index) {
            <div class="option-row" [formGroup]="$any(option_control)">
              <mat-form-field appearance="outline" class="option-label-field">
                <mat-label>Opción {{ option_index + 1 }}</mat-label>
                <input matInput formControlName="label" placeholder="Texto de la opción de respuesta" />
              </mat-form-field>
              <mat-checkbox formControlName="is_correct">Correcta</mat-checkbox>
              <button
                mat-icon-button
                type="button"
                color="warn"
                aria-label="Eliminar opción"
                [disabled]="options_form_array.length <= 1"
                (click)="removeOption(option_index)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </section>
      }

      @if (is_text_type()) {
        <section class="form-section rubric-section">
          <div class="section-header">
            <h2>Rúbrica de corrección</h2>
            <button
              mat-stroked-button
              type="button"
              class="rubric-ai-suggestion-button"
              [disabled]="!can_suggest_rubric_with_ai()"
              [matTooltip]="rubric_ai_suggestion_disabled_reason()"
              [matTooltipDisabled]="can_suggest_rubric_with_ai()"
              (click)="openRubricAiSuggestionDialog()"
            >
              @if (loading_rubric_suggestion()) {
                <mat-spinner class="rubric-ai-suggestion-button-spinner" diameter="18"></mat-spinner>
                <span>Generando sugerencia...</span>
              } @else {
                <mat-icon class="rubric-ai-suggestion-button-icon" aria-hidden="true">auto_awesome</mat-icon>
                <span>Sugerencia con IA</span>
              }
            </button>
          </div>
          <p class="section-hint">
            Obligatoria para preguntas de texto. Los pesos de las dimensiones deben sumar 100 %. Los pesos de los niveles no tienen que
            sumar 100 %. El % de cada celda es dimensión × nivel / 100.
          </p>

          <div class="rubric-config-row">
            <div class="rubric-block">
              <div class="rubric-header">
                <div class="rubric-header-title-block">
                  <h3>Dimensiones (filas)</h3>
                  <p
                    class="rubric-weights-hint"
                    [class.rubric-weights-hint-invalid]="rubric_dimensions_form_array.length > 0 && !rubric_weights_valid()"
                  >
                    Suma de pesos: {{ rubric_weights_sum() }} % (debe ser 100 %)
                  </p>
                </div>
                <button mat-stroked-button type="button" (click)="addRubricDimension()">
                  <mat-icon>add</mat-icon>
                  Dimensión
                </button>
              </div>
              @for (dimension_control of rubric_dimensions_form_array.controls; track $index; let dimension_index = $index) {
                <div class="rubric-row" [formGroup]="$any(dimension_control)">
                  <mat-form-field appearance="outline" class="small rubric-name-field">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name" placeholder="Ej. Claridad" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="small weight-field">
                    <mat-label>Peso %</mat-label>
                    <input matInput type="number" formControlName="weight_percent" min="1" max="100" placeholder="50" />
                  </mat-form-field>
                  <button
                    mat-icon-button
                    type="button"
                    color="warn"
                    aria-label="Eliminar dimensión"
                    [disabled]="rubric_dimensions_form_array.length <= 1"
                    (click)="removeRubricDimension(dimension_index)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>

            <div class="rubric-block">
              <div class="rubric-header">
                <h3>Niveles (columnas)</h3>
                <button mat-stroked-button type="button" (click)="addRubricLevel()">
                  <mat-icon>add</mat-icon>
                  Nivel
                </button>
              </div>
              @for (level_control of rubric_levels_form_array.controls; track $index; let level_index = $index) {
                <div class="rubric-row" [formGroup]="$any(level_control)">
                  <mat-form-field appearance="outline" class="small rubric-name-field">
                    <mat-label>Nivel {{ level_index + 1 }}</mat-label>
                    <input matInput formControlName="name" placeholder="Ej. Excelente" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="small weight-field">
                    <mat-label>Peso %</mat-label>
                    <input matInput type="number" formControlName="weight_percent" min="0" max="100" placeholder="25" />
                  </mat-form-field>
                  <button
                    mat-icon-button
                    type="button"
                    color="warn"
                    aria-label="Eliminar nivel"
                    [disabled]="rubric_levels_form_array.length <= 1"
                    (click)="removeRubricLevel(level_index)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>
          </div>

          @if (rubric_dimensions_form_array.length > 0 && rubric_levels_form_array.length > 0) {
            <div class="rubric-matrix-wrapper">
              <h3>Reglas de adjudicación por celda</h3>
              <table class="rubric-matrix-table">
                <thead>
                  <tr>
                    <th class="corner-cell"></th>
                    @for (level_control of rubric_levels_form_array.controls; track $index; let level_index = $index) {
                      <th>
                        <div class="matrix-header-cell">
                          <span class="matrix-header-name">{{ level_control.get('name')?.value || 'Nivel ' + (level_index + 1) }}</span>
                          <span class="matrix-header-percent">{{ level_control.get('weight_percent')?.value ?? 0 }} %</span>
                        </div>
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (dimension_control of rubric_dimensions_form_array.controls; track $index; let dimension_index = $index) {
                    <tr>
                      <th class="row-header-cell">
                        <div class="matrix-header-cell">
                          <span class="matrix-header-name">{{
                            dimension_control.get('name')?.value || 'Dimensión ' + (dimension_index + 1)
                          }}</span>
                          <span class="matrix-header-percent">{{ dimension_control.get('weight_percent')?.value ?? 0 }} %</span>
                        </div>
                      </th>
                      @for (_level_control of rubric_levels_form_array.controls; track $index; let level_index = $index) {
                        <td>
                          <div class="matrix-cell">
                            <span class="matrix-cell-percent"
                              >{{ rubric_cell_weight_percents()[dimension_index]?.[level_index] ?? 0 }} %</span
                            >
                            <textarea
                              class="rules-textarea"
                              rows="4"
                              placeholder="Reglas para adjudicar este nivel en esta dimensión..."
                              [value]="rubric_rules()[dimension_index]?.[level_index] ?? ''"
                              (input)="updateRubricRule(dimension_index, level_index, $any($event.target).value)"
                            ></textarea>
                          </div>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </section>
      }
    </form>
  }
</div>
